import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {ButtonProps} from "@mui/material"
import connect from "./connect"

export interface RecentSearchClearButtonProps extends ButtonProps {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    dataGaV1?: string
    dataGaV2?: string
    dataGaV3?: string
}

const RecentSearchClearButton = memo((props: RecentSearchClearButtonProps) => {
    const {mainTemplate, fallbackTemplate} = props.templating
    const TemplatedClearButton = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

    return (
        <Suspense>
            <TemplatedClearButton {...props} />
        </Suspense>
    )
})

RecentSearchClearButton.displayName = "RecentSearchClearButton"

export default connect(RecentSearchClearButton)
